import './style.scss'
import { IonSkeletonText } from '@ionic/react'
import clsx from 'clsx'

import Divider from '../../Divider'

import TalentCardPaper from '../_Core/TalentCardPaper'
import { useContext } from 'use-context-selector'
import { TalentCardContext } from '../_Core/Context'
import TopSkills from '../../TopSkills'
import TalentID from '../../TalentID'
import getSignature from '../../Certificate/getSignature'
import { CLUB_SHORT } from '../../../lib/apollo/config'
import { useImageFieldNormalization } from '../../../hooks/useImageFieldNormalization'

interface TalentCardMediumFrontProps {
  visible: boolean
  onFlipCardClick: () => void
}

const TalentCardMediumFront: React.FC<TalentCardMediumFrontProps> = ({ visible, onFlipCardClick }) => {
  const { certificate } = useContext(TalentCardContext)

  // Automatically normalize image fields if needed
  useImageFieldNormalization(certificate, {
    enabled: true,
    camp: certificate?.camp,
    onNormalizationStart: (participantId, type) => {
      console.log(`🚀 Starting image field normalization (${type}) for participant:`, participantId)
    },
    onNormalizationComplete: (participantId, result) => {
      console.log('✅ Image field normalization completed:', participantId, result)
    },
    onNormalizationError: (participantId, error) => {
      console.error('❌ Image field normalization failed:', participantId, error)
    }
  })

  if (!certificate) return null

  // Remove this component's image handling since the SVG handles it

  return (
        <TalentCardPaper
            className={clsx('talentcard-medium-front talentcard-medium-front--talent', {
              'talentcard-medium-front--visible': visible
            })}
        >
            <div
                className='talentcard-medium-front__top-container'
            >
                <div
                    className='display-flex-column ion-justify-content-center'
                    style={{ position: 'relative' }}
                >
                    <span>ALTER</span>
                    <h2 className='ion-text-center'>
                        {certificate.birthday ? new Date().getFullYear() - new Date(certificate.birthday).getFullYear() : ''}
                    </h2>
                    <img
                        className='talentcard-medium-front__fifa-country negative-margin'
                        alt='club img'
                        src={`/assets/${CLUB_SHORT}/logo.svg`}
                        style={{ right: '5px' }}
                    />
                </div>
            </div>

            <div
                className='talentcard-medium-front__bottom-container'
            >
                <div
                    className='talentcard-medium-front__profile-link'>
                    <h2
                        className='ion-text-center'
                    >
                        {certificate.caption ?? (
                            <IonSkeletonText
                                style={{ width: 200, margin: '0 auto 4px' }}
                            />
                        )}
                    </h2>
                </div>

                <Divider
                    margin={6}
                />

                <div
                    className='talentcard-medium-front__team-container'
                >
                    <div
                        className='talentcard-medium-front__team-container__meta'
                    >
                        <h4
                            className='ion-text-left'
                        >
                            {getSignature(certificate)}
                        </h4>
                        {/* <h4 */}
                        {/*    className='ion-text-left talentcard-medium-front__team' */}
                        {/* > */}
                        {/*    TEST2 */}
                        {/* </h4> */}
                    </div>
                </div>

                <Divider
                    margin={6}
                />

                <div
                    className='talentcard-medium-front__skills-wrapper'
                >
                    <TopSkills
                        values={certificate.vote}
                        talentClass={certificate.talentClass}
                        withValues={CLUB_SHORT === 'rbl'}
                    />

                    <div
                        className='talentcard-medium-front__talentid-wrapper'
                        tabIndex={-1}
                        role='button'
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onFlipCardClick?.()
                          }
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                          onFlipCardClick()
                        }}
                    >
                        <TalentID
                            values={certificate.vote}
                            talentClass={certificate?.talentClass === 2 ? '2' : '1'}
                        />
                    </div>

                </div>
            </div>
        </TalentCardPaper>
  )
}

export default TalentCardMediumFront
